/* eslint-disable no-case-declarations */
import * as TYPES from "~/store/patient/patientType";
import { find, get } from "lodash";

const INITIAL_STATE = {
  showLoading: false,
  patientList: [],
  redirectToCheckPatientPhone: false,
  showModalConfirm: false,
  searchHistoryList: [],
  confirmChecked: false,
  searchPatientByInfoList: [],
  loading: false,
  showModal: false,
  isAlertInfo: false,
  alertMsg: "",
  isWarningBHYT: false,
  warningBHYTMessage: "",
  errors: {},
  errorMessage: "",
  patientNumber: "",
  selectedPatientId: null,
  // patient: null,
  // selectedPatientDetail: null,
  selectedPatient: {},
  insuranceOfSelectedPatient: "",
  data: [],
  listPatientMedpro: {
    list: [],
    totalPage: "",
    totalCount: "",
    page: ""
  },
  listPatientSuggestion: {
    list: [],
    totalPage: "",
    totalCount: "",
    page: ""
  },
  phoneNumberVerify: "",
  formSearchPatientByInfo: {
    firstName: { value: "" },
    surName: { value: "" },
    gender: { value: -1 },
    birthYear: { value: 0 },
    cityId: { value: 0 }
  },
  secretKey: "",
  formCheckInsurance: {
    fullName: { value: "" },
    code: { value: "" },
    birthday: { value: "" }
  },
  typeInsurance: "",
  errorCheckInsurance: false,
  scanInsuranceSuccess: false,
  patientXNC: {
    profileCode: "",
    interviewDate: "",
    countryId: ""
  },
  typeCreate: ""
};

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.SET_TYPE_CREATE_PATIENT:
      return {
        ...state,
        typeCreate: action.value
      };
    case TYPES.POST_INFO_XNC:
      return {
        ...state,
        patientXNC: action.value
      };
    case TYPES.CLEAR_STATE:
      return { ...INITIAL_STATE };
    case TYPES.RESET_DATA:
      return {
        ...state,
        patientNumber: "",
        redirectToCheckPatientPhone: false
      };
    case TYPES.CHANGE_PATIENT_NUMBER:
      return {
        ...state,
        patientNumber: action.value,
        errorMessage: ""
      };
    case TYPES.SELECTED_PATIENT:
      return {
        ...state,
        selectedPatientId: action.value,
        selectedPatient:
          state.selectedPatient.id === action.value
            ? state.selectedPatient
            : state.patientList.length + state.data.length
              ? find([...state.patientList, ...state.data], { id: action.value })
              : state.selectedPatient,
        showModalConfirm: true
      };
    case TYPES.SELECTED_PATIENT_DETAIL:
      return {
        ...state,
        // selectedPatientDetail: action.value,
        selectedPatient: action.value,
        selectedPatientId: action.value.patientId
        // patient: action.value,
      };
    case TYPES.TOGGLE_MODAL_CONFIRM:
      return {
        ...state,
        showModalConfirm: !state.showModalConfirm
      };
    case TYPES.RESET_MODAL_CONFIRM:
      return {
        ...state,
        showModalConfirm: false
      };
    case TYPES.CHECK_CONFIRM:
      return {
        ...state,
        confirmChecked: !state.confirmChecked
      };
    case TYPES.RESET_CONFIRM_CHECK:
      return {
        ...state,
        confirmChecked: false
      };
    case TYPES.GET_PATIENT_BY_MSBN_REQUEST:
      return {
        ...state,
        errorMessage: ""
      };
    case TYPES.GET_PATIENT_BY_MSBN_SUCCESS:
      const patient = { ...action.patient[0] };
      return {
        ...state,
        selectedPatient: patient,
        selectedPatientId: patient.id,
        errorMessage: "",
        redirectToCheckPatientPhone: true
      };
    case TYPES.GET_PATIENT_BY_MSBN_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage
      };
    case TYPES.RESET_FORM_GET_PATIENT_BY_MSBN:
      return {
        ...state,
        errorMessage: ""
      };
    case TYPES.GET_PATIENT_BY_USERID_REQUEST:
      return {
        ...state,
        loading: true
      };
    case TYPES.GET_PATIENT_BY_USERID_SUCCESS:
      return {
        ...state,
        patientList: action.patientList,
        errorMessage: "",
        loading: false
      };
    case TYPES.GET_PATIENT_BY_USERID_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
        loading: false
      };
    case TYPES.DELETE_PATIENT_SUCCESS:
      return {
        ...state,
        errorMessage: ""
      };
    case TYPES.DELETE_PATIENT_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage
      };
    case TYPES.SHOW_LOADING:
      return { ...state, showLoading: true };
    case TYPES.HIDE_LOADING:
      return { ...state, showLoading: false };
    case TYPES.SEARCH_PATIENT_BY_INFO_REQUEST_SUCCESS:
      return {
        ...state,
        searchPatientByInfoList: action.searchPatientByInfoList,
        errorMessage: ""
      };
    case TYPES.SEARCH_PATIENT_BY_INFO_REQUEST_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage
      };

    // choose patient
    case TYPES.UMC_CHOOSE_PATIENT_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case TYPES.UMC_CHOOSE_PATIENT_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data
      };
    case TYPES.UMC_CHOOSE_PATIENT_LIST_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors
      };

    case TYPES.SELECT_PATIENT_REEXAM_SUCCESS: {
      const findPatient = action.payload;
      return {
        ...state,
        selectedPatient: {
          ...findPatient
          // insuranceCode: "BT27979312978131" // test case
        },
        selectedPatientId: findPatient.id,
        showModal: true,
        formCheckInsurance: {
          ...state.formCheckInsurance,
          fullName: { value: findPatient.fullname },
          code: { value: findPatient.insuranceCode },
          birthday: { value: findPatient.birthdate }
        }
      };
    }

    case TYPES.SELECT_PATIENT_FROM_LIST: {
      const id = action.id;
      const list = get(state, "data");

      const findPatient = list?.find(item => item.id === id);

      if (typeof findPatient !== typeof undefined) {
        return {
          ...state,
          selectedPatient: {
            ...findPatient
          },
          selectedPatientId: id,
          showModal: true,
          formCheckInsurance: {
            ...state.formCheckInsurance,
            fullName: { value: findPatient.fullname },
            code: { value: findPatient.insuranceCode },
            birthday: { value: findPatient.birthdate }
          }
        };
      } else {
        return {
          ...state,
          selectedPatient: {},
          selectedPatientId: null,
          showModal: false,
          formCheckInsurance: {
            ...INITIAL_STATE.formCheckInsurance
          }
        };
      }
      // return state;
    }
    case TYPES.SELECT_PATIENT_FROM_DATA: {
      return {
        ...state,
        selectedPatient: { ...action.payload },
        selectedPatientId: action.payload?.patientId || action.payload?.id
      };
    }
    case TYPES.TOGGLE_MODAL_CHOOSE_PATIENT:
      return {
        ...state,
        showModal: !state.showModal
      };
    case TYPES.RESET_MODAL_CHOOSE_PATIENT:
      return {
        ...state,
        showModal: false
      };

    case TYPES.SET_PATIENTID:
      return {
        ...state,

        selectedPatientId: action.id
      };

    case TYPES.SELECTED_PATIENT_AFTER_CREATE:
      return {
        ...state,
        selectedPatient: { ...action.selectedPatient },
        selectedPatientId: action.selectedPatient.id
      };
    case TYPES.UPDATE_SELECTED_PATIENT:
      return {
        ...state,
        selectedPatient: { ...action.patient },
        selectedPatientId: action.patient.id
      };
    case TYPES.SHOW_ALERT_INFO_CHOOSE_PATIENT:
      return {
        ...state,
        isAlertInfo: true,
        alertMsg: action.alertMsg
      };
    case TYPES.HIDE_ALERT_INFO_CHOOSE_PATIENT:
      return {
        ...state,
        isAlertInfo: false,
        ertMsg: ""
      };
    case TYPES.SHOW_WARNING_BHYT:
      return {
        ...state,
        isWarningBHYT: true,
        warningBHYTMessage: action.message
      };
    case TYPES.HIDE_WARNING_BHYT:
      return {
        ...state,
        isWarningBHYT: false,
        warningBHYTMessage: ""
      };
    case TYPES.RESET_REDIRECT_TO_CHECK_PHONE:
      return {
        ...state,
        redirectToCheckPatientPhone: false
      };

    case TYPES.CHECK_INSURANCE_SUCCESS:
      return {
        ...state,
        insuranceOfSelectedPatient: action.data,
        errorCheckInsurance: false
      };
    case TYPES.CHECK_INSURANCE_OF_PATIENT_FAILED:
      return {
        ...state,
        errorCheckInsurance: true
      };

    case TYPES.RESET_ERROR_CHECK_INSURANCE:
      return {
        ...state,
        errorCheckInsurance: false
      };

    // Gom chung patient
    case TYPES.GET_MEDPRO_PATIENT_LIST_SUCCESS:
      return {
        ...state,
        listPatientMedpro: {
          ...state.listPatientMedpro,
          list: action.data.data,
          totalCount: action.data.total_count,
          totalPage: action.data.total_page,
          page: action.data.page
        }
      };
    case TYPES.GET_MEDPRO_PATIENT_LIST_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors
      };
    case TYPES.GET_MEDPRO_PATIENT_SUGGESTION_LIST_SUCCESS:
      return {
        ...state,
        listPatientSuggestion: {
          ...state.listPatientSuggestion,
          list: action.data.data,
          totalCount: action.data.total_count,
          totalPage: action.data.total_page,
          page: action.data.page
        }
      };
    case TYPES.GET_MEDPRO_PATIENT_SUGGESTION_LIST_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors
      };

    // news
    case TYPES.VERIFY_PHONE_PATIENT:
      return {
        ...state,
        phoneNumberVerify: action.payload,
        secretKey: "",
        showLoading: true
      };
    case TYPES.VERIFY_PHONE_PATIENT_SUCCESS:
      return {
        ...state,
        selectedPatient: action.payload.patient,
        secretKey: action.payload.secretKey,
        showLoading: false,
        phoneNumberVerify: ""
      };

    case TYPES.VERIFY_PHONE_PATIENT_FAILURE:
      return {
        ...state,
        errorMessage: action.payload.message,
        showLoading: false
      };
    // search patient by info
    case TYPES.SAVE_FIELD_FORM_SEARH_PATIENT_BY_INFO:
      return {
        ...state,
        formSearchPatientByInfo: {
          ...state.formSearchPatientByInfo,
          ...action.payload
        }
      };

    case TYPES.SAVE_FIELD_FORM_CHECK_INSURANCE:
      return {
        ...state,
        formCheckInsurance: {
          ...state.formCheckInsurance,
          ...action.payload
        }
      };
    case TYPES.RESET_FORM_CHECK_INSURANCE:
      return {
        ...state,
        formCheckInsurance: {
          ...INITIAL_STATE.formCheckInsurance
        },
        errorCheckInsurance: false
      };
    case TYPES.UPDATE_FORM_CHECK_INSURANCE: {
      return {
        ...state,
        formCheckInsurance: action.payload
      };
    }

    case TYPES.SCAN_QR_CODE_INSURANCE_SUCCESS: {
      return {
        ...state,
        scanInsuranceSuccess: true
      };
    }
    case TYPES.RESET_STATUS_SCAN_QR_CODE_INSURANCE: {
      return {
        ...state,
        scanInsuranceSuccess: false
      };
    }

    // skip check mobile
    case TYPES.VERIRY_PATIENT_WITHOUT_PHONE: {
      return {
        ...state,
        secretKey: action.key
      };
    }

    default:
      return state;
  }
};
